export default {
  methods: {
    desensitizeIdCard(idCard) {
      if (!idCard) return '';
      const len = idCard.length;
      if (len !== 15 && len !== 18) return '证件号格式错误';
      return idCard.substring(0, 3) + '*'.repeat(len - 7) + idCard.substring(len - 4);
    },
    desensitizeName(name) {
      if (!name) return '';
      const nameLength = name.length;
      if (nameLength <= 1) return name;
      if (nameLength === 2) {
        return name.charAt(0) + '*';
      }
      return name.charAt(0) + '*'.repeat(nameLength - 2) + name.charAt(nameLength - 1);
    },
    desensitizePhone(phone) {
      if (!phone) return '';
      const phoneStr = String(phone);
      if (phoneStr.length !== 11) return '手机号格式错误';
      return phoneStr.substring(0, 3) + '****' + phoneStr.substring(7);
    }
  }
}
